import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';

export interface RoleplayAiSubtitleProps {
  lastAiContent: string;
  enableSubtitles: boolean;
  isSmallScreen: boolean;
  isSubtitleExpanded: boolean;
  onSubtitleExpandedChange: (expanded: boolean) => void;
}

export const RoleplayAiSubtitle: React.FC<RoleplayAiSubtitleProps> = ({
  lastAiContent,
  enableSubtitles,
  isSmallScreen,
  isSubtitleExpanded,
  onSubtitleExpandedChange,
}) => {
  if (!enableSubtitles || !lastAiContent) return null;

  if (isSmallScreen) {
    return (
      <Box sx={{
        width: '100%',
        bgcolor: '#25507A',
        color: '#fff',
        padding: '10px',
        textAlign: 'center',
        margin: '0 auto',
        marginTop: '-8px',
        zIndex: 4,
        position: 'relative',
      }}>
        <Box sx={{
          maxHeight: isSubtitleExpanded ? 'none' : '80px',
          overflow: isSubtitleExpanded ? 'visible' : 'hidden',
          position: 'relative',
          mb: isSubtitleExpanded ? 2 : 0,
          fontSize: '0.875rem',
        }}>
          {lastAiContent}
          {!isSubtitleExpanded && (
            <Box sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '30px',
              background: 'linear-gradient(transparent, rgba(37,80,122,0.9))',
              pointerEvents: 'none',
            }} />
          )}
        </Box>
        <IconButton
          onClick={() => onSubtitleExpandedChange(!isSubtitleExpanded)}
          size="small"
          sx={{
            color: '#ffffff',
            mt: 1,
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
            padding: '0',
          }}
          aria-label={isSubtitleExpanded ? '折りたたむ' : '展開する'}
        >
          {isSubtitleExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      </Box>
    );
  }

  return (
    <Box sx={{
      width: '100%',
      bgcolor: 'rgba(37,80,122,0.75)',
      color: '#fff',
      borderRadius: '0 0 18px 18px',
      padding: '24px 32px 20px 32px',
      fontSize: '17px',
      lineHeight: 1.7,
      textAlign: 'center',
      margin: '0 auto',
      zIndex: 4,
      position: 'relative',
    }}>
      {lastAiContent}
    </Box>
  );
};
